import React from 'react';
import moment from 'moment';
import Section, { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import DateFormat from 'constants/date_format';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const formatDate = date => moment(date).format(DateFormat.LONG_AT_TIME);

const History = ({ event }) => (
  <Section>
    <div>
      <SectionHeader>
        {t('in_person_training.event_overview.created')}
      </SectionHeader>
      <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4">
        {formatDate(event.created_at.date)}
      </Text>
      <div>
        <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
          {t('conjunctions.by')} {event.created_at.user}
        </Text>
      </div>
    </div>
    {event.last_updated_at.date && (
      <div className="mt-16">
        <SectionHeader>{t('common.last_updated')}</SectionHeader>
        <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4">
          {formatDate(event.last_updated_at.date)}
        </Text>
        <div>
          <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
            {t('conjunctions.by')} {event.last_updated_at.user}
          </Text>
        </div>
      </div>
    )}
  </Section>
);

export default History;
